import { css } from '@emotion/react'

export const styles = css`
  .custom-content-marker {
    width: 20px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    pointer-events: none;
  }
  .custom-icon {
    width: 20px;
    height: 28px;
  }
  .marker-num {
    position: absolute;
    padding: 0;
    color: #294846;
    font-size: 12px;
    margin-bottom: 5px;
  }
  .marker-active-num {
    position: absolute;
    padding: 0;
    color: #fff;
    font-size: 12px;
    margin-bottom: 5px;
  }
  .close-btn {
    width: 14px;
    height: 14px;
    position: absolute;
    top: -6px;
    right: -8px;
    z-index: 10000;
  }
  .close-btn-img {
    width: 14px;
    height: 14px;
    z-index: 10000;
  }
  .amap-sug-result {
    height: 170px;
    overflow: auto;
    border: none !important;
    background: #fff !important;
    border-radius: 4px !important;
    box-shadow: 0 1px 10px -1px rgba(0, 0, 0, 0.1) !important;
  }
  .auto-item {
    margin-top: 12px;
    padding-left: 12px;
    white-space: nowrap;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    cursor: pointer;
    &:hover {
      background-color: rgba(0, 86, 254, 0.1);
    }
  }
`
